import { FileImageFilled, MoreOutlined } from '@ant-design/icons'
import { DriveFile } from '@prisma/client'
import { Card, Dropdown, Flex, Typography } from 'antd'
import { RenderMarkdownContent } from '~/features/chatV3/client/components/Thread/components/RenderMarkdownContent'
import { Toolbox } from '~/plugins/toolbox/shared'

type Props = {
  file: DriveFile
  onSelect: (driveFileId: string) => void
  onDelete: (driveFile: DriveFile) => void
}

export const FileCard: React.FC<Props> = ({ file, onSelect, onDelete }) => {
  if (!file) {
    return <>No file found</>
  }

  if (['plain/text', 'text/plain'].includes(file.mimetype)) {
    return (
      <div style={{ maxWidth: '600px' }}>
        <Card
          hoverable
          onClick={() => onSelect(file.id)}
          style={{
            borderRadius: '12px',
            backgroundColor: '#fcfcfd',
          }}
          styles={{ body: { padding: '0px' } }}
        >
          <Flex
            align="center"
            justify="space-between"
            style={{
              padding: '8px 12px',
              overflow: 'hidden',
            }}
          >
            <Typography.Text
              ellipsis
              title={file.name}
              style={{
                margin: 0,
                fontSize: '12px',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {file.name}
            </Typography.Text>

            <Dropdown
              menu={{
                items: [
                  {
                    label: 'Edit',
                    key: 'edit',
                    onClick: event => {
                      onSelect(file.id)
                      event.domEvent.stopPropagation()
                    },
                  },
                  {
                    label: 'Delete',
                    key: 'delete',
                    onClick: event => {
                      onDelete(file)
                      event.domEvent.stopPropagation()
                    },
                  },
                ],
              }}
              trigger={['click']}
            >
              <MoreOutlined
                style={{ cursor: 'pointer' }}
                onClick={e => e.stopPropagation()}
              />
            </Dropdown>
          </Flex>
          <div className="mr-2 ml-2">
            <Card
              style={{
                height: '250px',
                width: '100%',
                overflowY: 'hidden',
                overflowX: 'hidden',
                padding: 0,
              }}
            >
              <Flex
                vertical
                gap={8}
                align="flex-start"
                justify="flex-start"
                style={{
                  transform: 'scale(0.5)',
                  transformOrigin: 'top left',

                  width: '200%', // Compensate for the scaling (1/0.85 ≈ 1.18)
                }}
              >
                <RenderMarkdownContent content={file.content} />
              </Flex>
            </Card>
          </div>
          <Flex justify="end" gap="8px" className="p-2">
            <Typography.Text type="secondary">
              {Toolbox.Date.toAsanaStyle(file.createdAt)}
            </Typography.Text>
          </Flex>
        </Card>
      </div>
    )
  }

  return (
    <div style={{ maxWidth: '600px' }}>
      <Card
        hoverable
        onClick={() => onSelect(file.id)}
        style={{
          borderRadius: '12px',
          backgroundColor: '#fcfcfd',
        }}
        styles={{ body: { padding: '0px' } }}
      >
        <Flex
          align="center"
          justify="space-between"
          className="mr-3 ml-3 mt-2 mb-1"
        >
          <Flex align="center">
            <Typography.Text
              ellipsis
              style={{ margin: 0, maxWidth: '230px', fontSize: '12px' }}
            >
              {file.name}
            </Typography.Text>
          </Flex>
          <Dropdown
            menu={{
              items: [
                {
                  label: 'Edit',
                  key: 'edit',
                  onClick: () => onSelect(file.id),
                },
                {
                  label: 'Delete',
                  key: 'delete',
                  onClick: () => onDelete(file),
                },
              ],
            }}
            trigger={['click']}
          >
            <MoreOutlined
              style={{ cursor: 'pointer' }}
              onClick={e => e.stopPropagation()}
            />
          </Dropdown>
        </Flex>
        <div className="mr-2 ml-2">
          <Card
            style={{
              height: '250px',
              width: '100%',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <FileImageFilled style={{ fontSize: '40px' }} />
          </Card>
        </div>
        <Flex justify="end" gap="8px" className="p-2">
          <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
            {Toolbox.Date.toAsanaStyle(file.createdAt)}
          </Typography.Text>
        </Flex>
      </Card>
    </div>
  )
}
